import { ChevronRight } from 'lucide-react';
import maneLogo from '../assets/MANE_logo1.png';
import heroBackground from '../assets/hero-background.jpg';

export default function Home() {
  const scrollToJoin = () => {
    window.location.href = '/join';
  };

  return (
    <section 
      id="home" 
      className="pt-24 pb-16 px-4 sm:px-6 lg:px-8 bg-michigan-blue min-h-screen flex items-center relative overflow-hidden"
    >
      {/* Background Image with Overlay */}
      <div 
        className="absolute inset-0 bg-cover bg-center bg-no-repeat opacity-20"
        style={{ backgroundImage: `url(${heroBackground})` }}
      />
      <div className="absolute inset-0 bg-michigan-blue opacity-60" />
      
      {/* Content */}
      <div className="max-w-7xl mx-auto relative z-10">
        <div className="text-center">
          <div 
            className="flex justify-center mb-6"
            data-aos="zoom-in"
          >
            <div className="bg-clear p-0.1 rounded-full shadow-lg">
              <img src={maneLogo} alt="MANE Logo" className="w-80 h-80" />
            </div>
          </div>
          <h1 
            className="text-5xl font-bold text-white mb-6"
            data-aos="fade-down"
            data-aos-delay="200"
          >
            Michigan Advocates for Nuclear Energy
          </h1>
          <p 
            className="text-xl text-blue-100 mb-8 max-w-3xl mx-auto"
            data-aos="fade-up"
            data-aos-delay="400"
          >
            Educating the University of Michigan and Ann Arbor communities about the science, safety, and promise of nuclear energy.
          </p>
          <button 
            onClick={scrollToJoin}
            className="bg-michigan-maize text-michigan-blue px-8 py-3 rounded-lg font-bold hover:bg-yellow-400 transition shadow-lg inline-flex items-center space-x-2"
            data-aos="fade-up"
            data-aos-delay="600"
          >
            <span>Join Our Mission</span>
            <ChevronRight className="w-5 h-5" />
          </button>
        </div>
      </div>
    </section>
  );
}
